import { render } from "./ColorChip.vue?vue&type=template&id=b2e99b00&scoped=true"
import script from "./ColorChip.vue?vue&type=script&lang=js"
export * from "./ColorChip.vue?vue&type=script&lang=js"

import "./ColorChip.vue?vue&type=style&index=0&id=b2e99b00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e99b00"]])

export default __exports__